import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../assets/styles/AnalticPage.css'; 
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';

const AnalyticPage = () => {
  const { formId } = useParams();
  const [initiativeData, setInitiativeData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  useEffect(() => {
    const fetchInitiativeData = async () => {
      try {
        const response = await fetch(`https://api.startupdriver.co/api/responses/analytics/${formId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setInitiativeData(data);
      } catch (error) {
        console.error("Veri çekilirken hata oluştu:", error);
      }
    };
    fetchInitiativeData();
  }, [formId]);

  const savePercentageScore = async (initiativeId, percentageScore) => {
    try {
      // Ensure percentageScore is not null before sending to API
      if (percentageScore === null || percentageScore === undefined) {
        console.warn(`Skipping update for initiative ${initiativeId} due to null percentage score`);
        return;
      }
      
      const response = await fetch(`https://api.startupdriver.co/api/responses/update-percentage-score/${initiativeId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ percentageScore }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Percentage score updated:', data);
    } catch (error) {
      console.error('Error updating percentage score:', error);
    }
  };
  
  // Example usage within your component
  useEffect(() => {
    initiativeData.forEach((initiative) => {
      if (initiative && initiative.initiativeId) {
        savePercentageScore(initiative.initiativeId, initiative.percentageScore);
      }
    });
  }, [initiativeData]);

  const sortedData = React.useMemo(() => {
    let sortableData = [...initiativeData];
    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [initiativeData, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="main-page">
      <Sidebar />
      <div className="content">
        <div className="table-container">
          <h2 className='analytic-head'>Startup Ranking Tool</h2>
          <table className="styled-table">
            <thead>
              <tr>
                <th>Initiative Name</th>
                <th>
                  <span className="tooltip" data-tooltip="Initiative's score based on the weights assigned to questions and answers in the form.">Performance Score</span>
                </th>
                <th>
                  <span className="tooltip" data-tooltip="The maximum total score that can be obtained according to the weights you give to the questions and answers while creating the form.">Potential Score</span>
                </th>
                <th onClick={() => requestSort('percentageScore')}>
                  <span className="tooltip" data-tooltip="The percentage adequacy of the score the initiative received">
                    Percentage of Compliance
                  </span>
                </th>
                <th onClick={() => requestSort('currentMrr')}>
                  <span className="tooltip" data-tooltip="Initiaive's current month MRR">Current MRR</span>
                </th>
                <th onClick={() => requestSort('monteCarloMean')}>
                  <span className="tooltip" data-tooltip="Monte Carlo mean score for this initiative">Monte Carlo Mean</span>
                </th>
               
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((initiative) => (
                <tr key={initiative.initiativeId}>
                  <td data-label="Initiative Name">{initiative.initiativeName}</td>
                  <td data-label="Performance Score">{initiative.userTotalWeight}</td>
                  <td data-label="Potential Score">{initiative.generalTotalWeight}</td>
                  <td data-label="Percentage of Compliance">
                    {initiative.percentageScore !== null && initiative.percentageScore !== undefined 
                      ? `${initiative.percentageScore.toFixed(2)}%` 
                      : 'N/A'}
                  </td>
                  <td data-label="Current MRR">
                    {initiative.currentMrr !== null && initiative.currentMrr !== undefined 
                      ? `$${initiative.currentMrr}` 
                      : 'N/A'}
                  </td>
                  <td data-label="Monte Carlo Mean">
                    {initiative.calculatedMetrics?.monteCarloMean !== null && 
                     initiative.calculatedMetrics?.monteCarloMean !== undefined 
                      ? initiative.calculatedMetrics.monteCarloMean.toFixed(2) 
                      : 'N/A'}
                  </td>
                  <td data-label="Details">
                    <Link to={`/initiative-detail/${initiative.initiativeId}`}>
                      <button className="details-button">Details</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AnalyticPage;